import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
interface ProtocoloSectionProps {
  handlePurchase: () => void;
}
export function ProtocoloSection({
  handlePurchase
}: ProtocoloSectionProps) {
  const includes = ['Manual Maestro de Abundancia (PDF Alta Resolución)', 'Audio de Frecuencia 888Hz (MP3 Alta Fidelidad)', 'Guía de Activación de 21 Días', 'Protocolo de Reprogramación Nocturna', 'Acceso Inmediato y de Por Vida', 'Actualizaciones 2026 Incluidas'];
  return <section id="protocolo" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-[#0f0f11] relative border-t border-white/5" data-id="element-121">
      <div className="max-w-[1000px] mx-auto" data-id="element-122">
        <div className="bg-dark border border-gold/30 rounded-2xl p-6 sm:p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.1)]" data-id="element-123">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-124">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.6
          }} style={{
            opacity: 1
          }} data-id="element-125">
              <h2 className="font-serif text-3xl md:text-4xl font-black mb-6" data-id="element-126">
                EL PROTOCOLO <br data-id="element-127" />
                <span className="text-gold" data-id="element-128">COMPLETO</span>
              </h2>
              <p className="opacity-80 mb-8" data-id="element-129">
                Todo lo que necesitas para iniciar tu reprogramación
                neuro-cuántica hoy mismo.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-130">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-131">
                    <CheckCircle2Icon className="w-6 h-6 text-gold shrink-0" data-id="element-132" />
                    <span className="opacity-90" data-id="element-133">{item}</span>
                  </li>)}
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.6
          }} className="text-center bg-white/5 p-8 rounded-xl border border-white/10" style={{
            opacity: 1
          }} data-id="element-134">
              <div className="mb-6" data-id="element-135">
                <span className="line-through opacity-50 text-xl mr-3" data-id="element-136">
                  $47.00
                </span>
                <span className="text-5xl font-black text-gold" data-id="element-137">$6.39</span>
              </div>
              <p className="text-sm opacity-70 mb-8" data-id="element-138">
                Pago único. Sin suscripciones ocultas.
              </p>

              <button onClick={handlePurchase} className="bg-gold text-dark border-none py-4 px-6 text-base font-black rounded cursor-pointer transition-all duration-300 shadow-[0_10px_25px_rgba(212,175,55,0.3)] w-full hover:scale-[1.03] hover:bg-[#f1c40f]" data-id="element-139">
                DESCARGAR AHORA — $6.39
              </button>

              <div className="mt-6 flex items-center justify-center gap-2 opacity-60 text-xs" data-id="element-140">
                <span data-id="element-141">🔒 Compra 100% Segura y Encriptada</span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}